<template>
  <div class="my-loan">
    <header-img :list="headerList"></header-img>
    <div class="main-block">
      <div class="top-title">通知中心</div>
      <!-- <div class="table" v-for="item in list" :data="item" :key="item.id" @click="handleChange(item)">
      <div class="tb-row">
        <div class="tb-col title vc">{{item.notice_time}}</div>
        <div class="tb-col other">{{item.notice_message}}</div>
      </div>
    </div> -->
      <div class="tabless">
        <el-collapse accordion @change="handleChange">
          <el-collapse-item v-for="item in list" :key="item.id" :name="item.id">
            <template slot="title">
              <div class="titles">
                <div class="a" :class="{ isread: item.isRead != 1 }">
                  {{ item.noticeTitle }}
                </div>
                <div class="b">
                  <span v-if="item.isRead == 1" class="reads">已读</span>
                  <span v-else class="isreads">未读</span>
                  {{ formatterTime(item.createDate) }}
                </div>
              </div>
            </template>
            <div class="tb-row">
              <div>{{ item.noticeMessage }}</div>
            </div>
          </el-collapse-item>
        </el-collapse>
      </div>
      <el-pagination
        style="text-align: center"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="search.pageNumber"
        :page-size="search.pageSize"
        layout="total, prev, pager, next,jumper"
        :total="total">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { dateFtt2 } from "@/utils/timeFormat";
import HeaderImg from "@/components/HeaderImg";
export default {
  components: {
    HeaderImg,
  },
  data() {
    return {
      search: {
        pageNumber: 1,
        pageSize: 10,
        userId: this.$store.state.userInfo.id,
        type: 2,
      },
      list: [],
      total: 0,
      activeNames: 0,
      comment: false,
      headerList: [
        { name: "首页", path: "/Home" },
        { name: "通知中心" },
      ],
    };
  },
  methods: {
    formatterTime(row) {
      if (row) {
        return dateFtt2("YYYY-mm-dd HH:MM:SS", row);
      } else {
        return "--";
      }
    },
    handleSizeChange(val) {
      this.search.pageSize = val;
      this.getDataList();
    },
    handleCurrentChange(val) {
      this.search.pageNumber = val;
      this.getDataList();
    },
    getDataList() {
      this.$api.my.noticeList(this.search).then((response) => {
        if (response.code == 1000) {
          this.list = response.data;
          this.total = response.total;
          let read = response.data.filter((item) => item.isRead != 1);
          if (read.length > 0) {
            this.comment = true;
          }
          this.$store.dispatch("cnoticeCenter", this.comment);
        } else {
          this.$message.error(response.message);
        }
      }).catch((error) => {});
    },
    handleChange(val) {
      if (val) {
        this.Loading = true;
        this.$api.my.noticeDoneReadDetail({ id: val }).then((res) => {
          if (res.code == 1000) {
            this.list.forEach((item) => {
              if (item.id == val) {
                item.isRead = 1;
              }
            });
          } else {
            this.$message.error(res.message);
          }
        }).catch((error) => {}).finally(() => {
          this.Loading = false;
        });
      }
    },
  },
  mounted() {
    this.search.userId = this.$store.state.userInfo.id;
    this.getDataList();
  },
};
</script>
<style lang="scss" >
.tabless {
  .el-collapse-item__header {
    height: 70px !important;
  }
}
</style>
<style lang="scss" scoped>
.main-block {
  width: auto;
  max-width: 1200px;
  margin: 0 auto;
  background: #fff;
  padding: 20px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
.my-loan {
  /deep/ .el-form-item {
    margin-right: 18px;
  }
  .tabless {
    width: 1064px;
    margin: auto;
    margin-bottom: 20px;
    .titles {
      font-size: 16px;
      .reads {
        color: #aeaeae;
        background: rgba(122, 122, 122, 0.06);
        border: 1px solid #aeaeae;
      }
      .isreads {
        color: #f65248;
        background: rgba(240, 118, 74, 0.12);
        border: 1px solid #f65248;
      }
      .a {
        font-weight: 600;
        line-height: 1;
        font-size: 18px;
        color: #666666;
        padding-bottom: 5px;
      }

      .isread::before {
        content: "";
        width: 5px;
        height: 5px;
        background: #fff;
        border: 2px solid #f65248;
        border-radius: 50%;
        display: inline-block;
        margin-right: 5px;
      }
      .b {
        padding-top: 5px;
        line-height: 1;
        font-size: 14px;
        color: #999999;
        span:first-child {
          width: 37px;
          height: 16px;
          line-height: 16px;
          text-align: center;
          display: inline-block;
          font-size: 11px;
          margin-right: 15px;
        }
      }
    }
    .tb-row {
      display: flex;
      align-items: center;
      justify-content: flex-start;
    }
  }
}
</style>
